import { AdUnitForPageTransferList } from './adUnitForPageTransferList'

export const sorted = (list: AdUnitForPageTransferList[]): AdUnitForPageTransferList[] =>
  [...list].sort((a: AdUnitForPageTransferList, b: AdUnitForPageTransferList): number =>
    a.value.toLowerCase().localeCompare(b.value.toLowerCase()),
  )
